import { defineComponent, computed } from 'vue';
import { useStore } from 'vuex';
import { ContainerTitle, MainTitle } from '@/components';
import { AnalysisContainer } from '@/containers';
export default defineComponent({
    name: 'Analysis',
    components: {
        MainTitle,
        ContainerTitle,
        AnalysisContainer,
    },
    setup() {
        const store = useStore();
        const siteConfigurationInfo = computed(() => store.state.device.siteConfiguration ?? null);
        return { siteConfigurationInfo };
    },
});
